export const environment = {
  local: false,
  production: false,
  endpoint: 'https://dev-api.migration-dev.evermile.io',
  websocket: 'wss://dev-ws-api.migration-dev.evermile.io',
  chatScriptUrl: 'https://dev-webapp.migration-dev.evermile.io/chat-script/evermile.js',
  sentry_dsn: 'https://934ba886595b49d088b95503b14ca63d@o4504486649724928.ingest.sentry.io/4505142254305280',
  sentryEnabled: true,
  facebookAccessToken: '718391940123236|7cea5ba245585e575902d82c797647f1',
};
